import React from "react";

// Filigrane doré : instruments de musique & symboles Beti-Ekang.
// Trait doré sur fond noir profond -> fondu "screen" pour ne garder que les traits.
const WATERMARK = "https://static.prod-images.emergentagent.com/jobs/9aaee211-f63c-4a28-8edc-d5bfaad8b13c/images/31cfc8c2ea2314a75f68f82d3b92eddfa65da80552be89dc6cbeb3c53ead278f.jpeg";

export const ArtifactWatermark = () => (
  <div
    aria-hidden="true"
    data-testid="artifact-watermark"
    className="pointer-events-none fixed inset-0 z-[5]"
    style={{
      backgroundImage: `url(${WATERMARK})`,
      backgroundSize: "440px",
      backgroundRepeat: "repeat",
      mixBlendMode: "screen",
      opacity: 0.14,
    }}
  />
);

export default ArtifactWatermark;
